// Service page content for Temporary Graduate visa (Subclass 485).
// Sourced from docs/research/australian-visa-pathways.md §6.
// COMPLIANCE: we prepare and organise the file and coordinate the next steps; a
// registered migration agent confirms eligibility, advises on the pathway, and
// lodges. Honest that the 485 buys time, not PR; no unverified figures.

const graduate485 = {
  groupSlug: "student-graduate",
  slug: "graduate-485",
  title: "Graduate Visa (Subclass 485)",
  eyebrow: "Student & Graduate",
  intro:
    "The Subclass 485 lets recent graduates of Australian qualifications live and work in Australia temporarily after study. It is the bridge between finishing your course and building the work experience, English, and skills assessment you may need for a skilled or employer-sponsored visa.",

  chips: [
    { label: "Visa type", value: "Temporary, work rights" },
    { label: "Streams", value: "Post-Higher Education, Post-Vocational" },
    { label: "Apply within", value: "6 months of course completion" },
    { label: "Purpose", value: "Build toward a skilled pathway" },
  ],

  whoFor: [
    "Recent graduates of a CRICOS course who meet the Australian study requirement.",
    "Graduates who want time to gain Australian work experience.",
    "People planning a future skilled or employer-sponsored visa.",
  ],

  essentials: [
    {
      title: "A recent Australian qualification",
      detail:
        "You must have completed a CRICOS course meeting the Australian study requirement and apply within six months of completion.",
    },
    {
      title: "The right stream",
      detail:
        "The Post-Higher Education Work stream is for degree graduates, and the Post-Vocational Education Work stream is for VET and trade graduates. A second regional stream exists for some graduates.",
    },
    {
      title: "Under the age limit",
      detail:
        "A maximum age applies for most applicants, which was reduced in recent reforms. A registered migration agent confirms whether you are within it.",
    },
    {
      title: "English language",
      detail:
        "Required English scores apply and were raised recently. A registered migration agent confirms the current minimum.",
    },
    {
      title: "An eligible student visa history",
      detail:
        "You generally must have held an eligible student visa and meet the study requirement.",
    },
    {
      title: "Health insurance",
      detail:
        "You need adequate health insurance for the visa period.",
    },
  ],

  process: [
    {
      title: "Confirm your stream and eligibility",
      detail:
        "A registered migration agent confirms your stream and checks your qualification, age, English, and timing against the current 485 rules.",
    },
    {
      title: "Prepare your evidence",
      detail:
        "We help you assemble and organise your completion, English, and health cover evidence.",
    },
    {
      title: "Lodge within the window",
      detail:
        "We have your file ready within six months of course completion, and a registered migration agent lodges it and deals with the Department.",
    },
    {
      title: "Use the time well",
      detail:
        "We help you keep the moving parts organised, gaining experience, sitting English tests, and completing a skills assessment, while a registered migration agent advises on the pathway.",
    },
    {
      title: "Plan your next visa",
      detail:
        "A registered migration agent maps the route toward a skilled or employer-sponsored visa before your 485 ends, and we keep your documentation organised for it.",
    },
  ],

  faqs: [
    {
      q: "Does the 485 lead to permanent residence?",
      a: "Not directly. The 485 is temporary. Honestly, it buys you time in Australia to gain work experience, improve your English, and complete a skills assessment, which can strengthen a later skilled or employer-sponsored application. It does not deliver permanent residence on its own.",
    },
    {
      q: "Which stream am I in?",
      a: "Degree graduates generally use the Post-Higher Education Work stream, and VET or trade graduates use the Post-Vocational Education Work stream. Some regional graduates qualify for a second stream. A registered migration agent confirms which fits your qualification.",
    },
    {
      q: "How long do I have to apply?",
      a: "Generally within six months of completing your course. Timing matters, so we help you prepare early and have your file ready for a registered migration agent to lodge within the window.",
    },
    {
      q: "How should I use my 485 time?",
      a: "Strategically. The most successful graduates use it to gain relevant Australian work experience, lift their English, and get a skills assessment done, all of which feed a future skilled visa. A registered migration agent advises on the plan, and we help you keep it organised and moving from day one.",
    },
  ],

  related: ["student-500", "skills-assessment", "skilled-independent-189"],

  lastVerified: "13 July 2026",
};

export default graduate485;
